import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { decryptData } from '../AdminPortal/AdminImport';

const MentorAuthGuard = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  let parsedObject;
  const data = localStorage.getItem("userData");
  data ? parsedObject = decryptData(data, process.env.REACT_APP_USER_KEY) : navigate("/error/statusCode=400");

  const navigateAccordingToPermission = (str) => {
    const path = location.pathname;
    const permissionArray = str?.split(",");
    let session, review, project;
    permissionArray?.forEach((element) => {
      if (element === "Session") session = true;
      if (element === "Project") project = true;
      if (element === "Review") review = true;
    });
    if (path === "/mentor/dashboard" && session) {
      navigate(path);
    } else if (
      (path === "/lms/grade-assignment" || path === "/mentor/project-rating" || path === "/lms/grade-assignment/review-assignment-submission") &&
      (project || session)
    ) {
      navigate(path);
    } else if (
      path === "/lms/assigned-courses" || path.startsWith("/lms/assigned-courses/")
    ) {
      navigate(path);
    } else if (
      (path === "/mentor/review-associates" ||
        path === "/mentor/review-associates/inter-performance-review") &&
      review
    ) {
      navigate(path);
    } else {
      if (session) navigate("/mentor/dashboard");
      else if (project) navigate("/lms/grade-assignment");
      else if (review) navigate("/mentor/review-associates");
    }
  };

  const handleAuth = () => {
    if (localStorage.getItem("login")) {
      if (localStorage.getItem("login") === "false") {
        navigate("/");
        setIsAuthenticated(false);
      } else {
        const roleName = parsedObject.decoded.RoleName;
        const hrmsDesignationName = parsedObject.decoded.HrmsDesignationName?.toLowerCase();
        const permissionTypeName = parsedObject.decoded.PermissionTypeName;

        if (roleName === process.env.REACT_APP_USER_DES_ADMIN) {
          navigate(location.pathname);
        } else if (roleName === process.env.REACT_APP_USER_DES_USER) {
          if (hrmsDesignationName === "sde" || hrmsDesignationName === "intern") {
            navigate("/dashboard");
          } else {
            navigate(location.pathname);
          }
        } else {
          navigateAccordingToPermission(permissionTypeName);
        } setIsAuthenticated(true);
      }
    } else {
      navigate("/");
      setIsAuthenticated(false);
    }
  };
  useEffect(() => {
    handleAuth();
  }, [isAuthenticated]);

  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default MentorAuthGuard;
